// src/components/my_journey/PersonalStory.jsx
import React from "react";
import p1 from "../../assets/personal/personal_story/p1.jpg";
import p2 from "../../assets/personal/personal_story/p2.jpg";
import Personal_story_icon from "../../assets/my_journey_personal_story_icon.png";

export default function PersonalStory() {
  return (
    <section className="py-12 px-4 md:px-12 relative w-full">
      {/* Background overlay */}
      <div className="absolute inset-0 bg-black/30 backdrop-blur-sm z-0"></div>

      <div className="relative z-10 max-w-6xl w-full mx-auto flex flex-col gap-12">
        {/* Section Heading */}
        <div className="mb-8">
          {/* Heading */}
          <div className="flex items-center gap-4 w-full max-w-[90%] mb-8">
            <img
              src={Personal_story_icon}
              alt="Personal Story Icon"
              className="w-11 h-11 md:w-14 md:h-14"
            />
            <h1 className="text-white text-4xl md:text-5xl font-bold underline decoration-gray-400 decoration-1 underline-offset-2">
              My Pesonal Story
            </h1>
          </div>
          <p className="text-neonTurquoise italic text-lg md:text-xl mt-2 max-w-3xl text-left">
            A journey shaped by discipline, resilience, and discovery. Every
            challenge provided lessons that fueled my growth as a person and as
            a trainer.
          </p>
        </div>

        {/* First Story Block */}
        <div className="md:flex md:items-start md:gap-6 flex-col md:flex-row">
          <div className="md:w-1/2 flex flex-col gap-3">
            <p className="text-gray-200 text-lg md:text-xl leading-relaxed animate-fadeInLeft">
              Growing up surrounded by challenges, I quickly learned that
              resilience was earned, not given. Early mornings filled with
              training, unexpected obstacles, and moments of doubt became
              opportunities to strengthen my discipline and sharpen my focus.
              Each setback taught patience, determination, and the power of
              consistent effort.
            </p>
            <p className="text-gray-200 text-lg md:text-xl leading-relaxed animate-fadeInLeft delay-200">
              These formative experiences shaped not just my approach to fitness
              but my outlook on life. I discovered that true growth comes from
              embracing discomfort, learning from mistakes, and pushing beyond
              limits. The lessons I gained fueled my vision for Kalon Fitness,
              where perseverance, strategy, and mindful effort converge to
              empower others on their own journeys.
            </p>
          </div>
          <div className="md:w-1/2 flex justify-center relative animate-fadeInRight mt-4 md:mt-0">
            <img
              src={p1}
              alt="Early Journey"
              className="w-full md:h-[26rem] object-cover rounded-xl shadow-2xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
        </div>

        {/* Second Story Block */}
        <div className="md:flex md:items-start md:gap-6 flex-col md:flex-row-reverse">
          <div className="md:w-1/2 flex flex-col gap-3">
            <p className="text-gray-200 text-lg md:text-xl leading-relaxed animate-fadeInRight">
              Over the years, I realized that mastering physical strength alone
              was not enough. True growth required observation, reflection, and
              adaptation. By learning from experience, experimenting with
              techniques, and understanding the unique needs of each individual,
              I cultivated a more thoughtful and effective approach to training.
            </p>
            <p className="text-gray-200 text-lg md:text-xl leading-relaxed animate-fadeInRight delay-200">
              These insights shaped the vision behind Kalon Fitness, where
              innovation and discipline coexist. I focused on creating an
              environment that nurtures both the body and the mind, empowering
              individuals to push their boundaries, develop consistency, and
              achieve sustainable progress. Every challenge became a lesson, and
              every success a reminder of the potential within. This journey has
              been about building not just physical capability, but confidence,
              resilience, and purpose.
            </p>
          </div>
          <div className="md:w-1/2 flex justify-center relative animate-fadeInLeft mt-4 md:mt-0">
            <img
              src={p2}
              alt="Building Kalon Fitness"
              className="w-full md:h-[26rem] object-cover rounded-xl shadow-2xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
